import { namespace } from "vuex-class";

const moduleName = "route";
const moduleObject = namespace(moduleName);
export const RouteState = moduleObject.State;
